import React from 'react';

export default function GhostButton({ children, className = '', style = {}, ...props }) {
  return (
    <button
      {...props}
      className={`px-4 py-2 text-sm font-medium rounded-xl transition-colors ${className}`}
      style={{ color: '#6b7280', border: '1px solid #1e2130', ...style }}
      onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#1e2130'; e.currentTarget.style.color = '#e4e6f0'; }}
      onMouseLeave={e => { e.currentTarget.style.backgroundColor = 'transparent'; e.currentTarget.style.color = '#6b7280'; }}
    >
      {children}
    </button>
  );
}
